import React from "react";
import VehicleOrders from "./VehicleOrders";

export default function VehicleActiveOrders() {
  return <VehicleOrders type="active" />;
}
